import { render, staticRenderFns } from "./TenancyAction.vue?vue&type=template&id=39803bec"
import script from "./TenancyAction.vue?vue&type=script&lang=js"
export * from "./TenancyAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports